import { Link } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export default function Dashboard({ currentUser }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl font-bold">Hello World!</CardTitle>
          <CardDescription>
            Admin Dashboard
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-4">
          <div className="text-center space-y-2">
            <p className="text-zinc-600">
              Welcome, <span className="font-semibold">{currentUser.email}</span>
            </p>
            <p className="text-sm text-zinc-500">
              Role: <span className="capitalize">{currentUser.role}</span>
            </p>
          </div>
          <Button asChild variant="outline" className="w-full">
            <Link href="/logout" method="post" as="button">
              Sign Out
            </Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
